// Test IDs for reorder components

export const REORDER_LIST_TEST_IDS = {
  HEADER: 'reorder-list-header',
  TABLE_CONTENT: 'reorder-list-table-content',
  TABLE_HEADER_ORDER_DATE: 'reorder-list-table-header-order-date',
  TABLE_HEADER_PRODUCT: 'reorder-list-table-header-product',
  TABLE_HEADER_FABRIC: 'reorder-list-table-header-fabric',
  TABLE_HEADER_FIT: 'reorder-list-table-header-fit',
  TABLE_HEADER_SIZE: 'reorder-list-table-header-size',
} as const;

